import { makeAutoObservable, runInAction } from 'mobx'
import { nanoid } from 'nanoid'
import modalStore from 'shared/ui/Modal/store/modalStore'
import { logger } from 'shared/lib'
import { type IResponseMessageDetails, MessagesApi } from 'entities/Message'
import { type Message } from 'entities/Message/model/Message'
import { MessageDetailsModalContent } from 'widgets/MessageCard/ui/MessageDetailsModal/ui/MessageDetailsModalContent'

export class MessageDetailsModalStore {
  private _idModal = nanoid()
  private _loading = false
  private _messageDetails: IResponseMessageDetails | null = null

  constructor(private _message: Message) {
    makeAutoObservable(this)
  }

  private _fetchMessageDetails = async (messageId: number) => {
    try {
      runInAction(() => {
        this._loading = true
      })
      const { data: messageDetailsData } = await MessagesApi.getMessageDetailsAdmin(messageId)
      runInAction(() => {
        this._messageDetails = messageDetailsData
      })
    } catch (e) {
      logger.error(e)
    } finally {
      runInAction(() => {
        this._loading = false
      })
    }
  }

  openModal = () => {
    this._fetchMessageDetails(this._message.id)

    modalStore.addModal({
      id: this._idModal,
      title: 'Message details',
      showCloseButton: false,
      showCloseIcon: true,
      width: 720,
      ModalContent: MessageDetailsModalContent,
      ModalContentProps: {
        store: this,
      },
      onClose: this.closeModal,
    })
  }

  closeModal = () => {
    modalStore.removeModal(this._idModal)
  }

  get loading() {
    return this._loading
  }

  get messageDetails() {
    return this._messageDetails
  }

  get message() {
    return this._message
  }
}
